export const LIFECYCLE_WILL_ENTER = 'ionViewWillEnter';
export const LIFECYCLE_DID_ENTER = 'ionViewDidEnter';
export const LIFECYCLE_WILL_LEAVE = 'ionViewWillLeave';
export const LIFECYCLE_DID_LEAVE = 'ionViewDidLeave';
const ids = { main: 0 };
export const generateId = (type = 'main') => {
    var _a;
    const id = ((_a = ids[type]) !== null && _a !== void 0 ? _a : 0) + 1;
    ids[type] = id;
    return (id).toString();
};
// TODO types
export const fireLifecycle = (vueComponent, lifecycle) => {
    if (vueComponent && vueComponent.methods && vueComponent.methods[lifecycle]) {
        vueComponent.methods[lifecycle]();
    }
};
//# sourceMappingURL=utils.js.map